<!-- 机构概况-底部tab -->
<template>
  <div class="tab-component" id="tab">
    <news-tab
      @getCurrentTab="getCurrentTab"
      :methodsIncluding="'hover'"
    ></news-tab>
    <div class="mt16 tab-content">
      <div v-show="activeName == '中心概况'" class="flex central-functions">
        <p v-html="details.content" class="content"></p>
        <img :src="path + details.thumbnail" alt="" />
      </div>
      <div v-show="activeName == '科室职能'" class="flex department">
        <div class="left">
          <div
            v-for="(item, i) in departmentData"
            :key="i"
            @mouseover="onDepartmentName(item.functionDescription, i)"
            class="left-title flex-center"
            :class="isActiveI == i ? 'is-active' : ''"
          >
            <span class=""> {{ item.departmentName }}</span>
          </div>
        </div>
        <div class="right">
          <div class="content-container">
            <div class="description-wrapper">
              <div class="description" v-html="functionDescription"></div>
              <div
                class="link-text"
                @click="openLink(departmentData[isActiveI].linkUrl)"
              >
                <span class="mr5">{{
                  departmentData[isActiveI]
                    ? departmentData[isActiveI].linkName
                    : ""
                }}</span>
                {{
                  departmentData[isActiveI]
                    ? departmentData[isActiveI].linkUrl
                    : ""
                }}
              </div>
            </div>
            <div class="attachments">
              <template
                v-if="
                  departmentData[isActiveI] &&
                  departmentData[isActiveI].attachmentList
                "
              >
                <div
                  class="download-document flex"
                  v-for="(item, i) in departmentData[isActiveI].attachmentList"
                  :key="i"
                >
                  <i class="el-icon-paperclip"> </i>
                  <a
                    class="itemName text_overflow"
                    :href="path + item.path"
                    :download="'/' + item.name"
                    >{{ item.name }}</a
                  >
                  <i
                    class="el-icon-view"
                    @click="opendialog(path + item.path)"
                    v-if="str.includes(item.name.split('.')[1])"
                  ></i>
                  <a
                    class="el-icon-download"
                    :href="path + item.path"
                    :target="
                      str.includes(item.name.split('.')[1]) ? '_blank' : ''
                    "
                    :download="'/' + item.name"
                  >
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-show="activeName == '承检能力'" class="flex department">
        <div class="left">
          <div
            v-for="(item, i) in inspectionData"
            :key="i"
            @mouseover="onInspectionName(item, i)"
            class="left-title flex-center"
            :class="isActiveI == i ? 'is-active' : ''"
          >
            <span class=""> {{ item.inspectionName }}</span>
          </div>
        </div>
        <div class="right">
          <ul class="news-ul-li" style="height: 280px">
            <li
              class="space-between"
              v-for="(item, i) in listData"
              :key="i"
              @click="
                toDetails(
                  {
                    id: item.id,
                    title: '机构概况',
                    tag: '承检能力',
                  },
                  item.linkTo,
                )
              "
            >
              <p class="text_overflow" :title="item.title">{{ item.title }}</p>
              <span>{{
                item.publishedDate
                  ? item.publishedDate.split(" ")[0]
                  : item.createdDate.split(" ")[0]
              }}</span>
            </li>
          </ul>
          <div class="pagination" style="justify-content: center">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="params.page"
              :page-sizes="[10, 20, 50, 60]"
              :page-size="params.size"
              layout="total, sizes, prev, slot, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div v-show="activeName == '中心领导'" class="leader">
        <div class="boxlist">
          <div class="list-leadership" v-for="(item, i) in leaderData" :key="i">
            <span class="position"> {{ item.position }}</span>
            <span
              style="cursor: pointer"
              @click="
                onLeaderName(
                  {
                    id: item.id,
                    title: '机构概况',
                    tag: item.name + '_' + (item.position ? item.position.replace(/\s/g, '') : '')
                  },
                  item,
                )
              "
            >
              {{ item.name }}</span
            >
          </div>
        </div>
      </div>
      <div v-show="activeName == '联系方式'" class="map-info">
        <div class="map" @click="tomap"></div>
        <div class="info flex">
          <div @click="tomap" class="flex pointer">
            <img src="../../assets/images/info_icon0.webp" alt="" />
            <p>
              <b>单位地址</b>
              <span> 南宁市江南区国凯大道东19号 </span>
              <span>金凯工业园13号楼</span>
              <span>邮政编码: 530031</span>
            </p>
          </div>
          <div class="flex">
            <img src="../../assets/images/info_icon1.webp" alt="" />
            <p>
              <b>联系电话</b>
              <span>前台受理: 0771-2800500</span>
              <span>传真: 0771-2800566</span>
              <span>其他科室电话详见公众服务栏目</span>
            </p>
          </div>
          <div class="flex">
            <img src="../../assets/images/info_icon2.webp" alt="" />
            <p>
              <b>电子邮箱</b>
              <span>qjzx@yjj.gxzf.gov.cn</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%" fullscreen>
      <embed
        :src="pdfurl"
        width="100%"
        height="100%"
        type="application/pdf"
        v-if="pdfurl.includes('.pdf')"
      />
      <img :src="pdfurl" alt="" v-else />
    </el-dialog>
  </div>
</template>
<script>
import newsTab from "./../news/news-tab.vue";
import {
  getArticleDetails,
  getLeaderList,
  getDepartmentList,
  getArticleList,
  getKey,
} from "@/api/index";

export default {
  components: { newsTab },
  data() {
    return {
      activeName: "中心概况",
      details: {},
      departmentData: [],
      inspectionData: [],
      leaderData: [],
      functionDescription: "",
      createdDate: "",
      isActiveI: 0,
      str: ["jpg", "png", "jpeg", "pdf"],
      path: process.env.VUE_APP_BASE_API,
      listData: [],
      params: {
        page: 0,
        size: 10,
      },
      total: 0,
      dialogVisible: false,
      pdfurl: "",
    };
  },
  watch: {
    "$route.query": {
      handler(val) {
        if (val.hash) {
          this.scrollToAnchor("tab");
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 打开pdf预览框
    opendialog(url) {
      this.pdfurl = url;
      this.dialogVisible = true;
    },
    // 点击科室职能链接打开
    openLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    // 修改分页大小
    handleSizeChange(val) {
      this.params.page = 0;
      this.params.size = val;
      this.getArticleList();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 200);
    },
    // 点击分页
    handleCurrentChange(val) {
      this.params.page = val - 1;
      this.getArticleList();
    },
    toDetails(query, linkTo) {
      if (linkTo) {
        window.open(linkTo, "_blank");
      } else {
        this.$router.push({ path: "/details", query });
      }
    },
    onLeaderName(query, item) {
      if (item.linkTo) {
        window.open(item.linkTo, "_blank");
      } else {
        this.$router.push({ path: "/leader-details", query });
      }
    },
    getCurrentTab(activeName) {
      this.activeName = activeName;
    },
    tomap() {
      window.open(
        "https://map.baidu.com/poi/%E5%B9%BF%E8%A5%BF%E5%A3%AE%E6%97%8F%E8%87%AA%E6%B2%BB%E5%8C%BA%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E6%A3%80%E6%B5%8B%E4%B8%AD%E5%BF%83/@12057101.598829487,2585831.1455263617,20.32z?uid=2863c199f50218c3c909f040&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl",
        "_blank",
      );
    },
    getData() {
      // 获取中心概况的信息
      getArticleDetails(523)
        .then((res) => {
          this.details = res;
        })
        .finally(() => {});
      // 获取科室职能信息
      getDepartmentList()
        .then((res) => {
          this.departmentData = res.list;
          this.functionDescription = this.departmentData[0].functionDescription;
        })
        .finally(() => {});
      // 获取领导信息

      getLeaderList()
        .then((res) => {
          this.leaderData = res.list;
        })
        .finally(() => {});
    },
    // 获取承检能力的信息
    getInspectionData() {
      const key = "generalize.inspection.id";
      getKey({ key: key })
        .then((res) => {
          if (res && res.children) {
            this.inspectionData = res.children.map((item) => ({
              inspectionName: item.name,
              key: item.configKey,
            }));

            if (this.inspectionData.length > 0) {
              // 默认触发第一个分类的数据加载
              this.onInspectionName(this.inspectionData[0], 0);
            }
          } else {
            this.inspectionData = [];
          }
        })
        .catch((err) => {
          console.error("Failed to get download center data:", err);
          this.inspectionData = [];
        });
    },
    // 点击承检能力分类
    onInspectionName(item, i) {
      this.isActiveI = i;
      this.getArticleList(item.key);
    },
    getArticleList(key) {
      const params = {
        page: this.params.page,
        size: this.params.size,
        key: key,
      };
      getArticleList(params)
        .then((res) => {
          this.total = res.count;
          this.listData = res.list;
        })
        .finally(() => {});
    },
    // 点击科室标题
    onDepartmentName(data, i) {
      this.functionDescription = data;
      this.isActiveI = i;
    },
    scrollToAnchor(id) {
      this.$nextTick(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "center" });
        }
      });
    },
  },
  mounted() {
    if (this.$route.hash) {
      this.scrollToAnchor("tab");
    }
    this.getData();
    this.getInspectionData();
    if (this.inspectionData.length > 0) {
      this.getArticleList(this.inspectionData[0].key);
    }
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.tab-component {
  width: 100%;
  flex: 1;
  background-size: cover !important;
  margin-top: 32px;
  margin-bottom: 32px;
  .tab-content {
    height: 442px;
  }
  .central-functions {
    img {
      width: 470px;
      height: 442px;
    }
    .content {
      overflow: auto;
      height: 442px;
      margin-bottom: 0;
    }
  }
  .department {
    width: 100%;
    height: 100%;

    background: url(../../assets/images/back.webp) no-repeat;
    background-size: 100% 100%;
    padding: 8px;
    .left {
      height: 100%;
      overflow: auto;
      min-width: 246px;
    }
    .left-title {
      height: 45px;
      width: 217px;
      background: #e4edfa;
      margin-bottom: 2px;
      text-align: center;
      font-weight: 400;
      font-size: 18px;
      color: #1e1e1e;
      cursor: pointer;
      position: relative;
      padding: 0 12px;
    }
    .is-active {
      background: #1b6ad2;
      color: #fff;
    }
    .is-active::after {
      content: "";
      height: 45px;
      position: absolute;
      display: block;
      top: 0;
      right: -23px;
      width: 0px;
      height: 0px;
      border-top: 23px solid transparent; /* 上边框 */
      border-bottom: 22px solid transparent; /* 下边框 */
      border-left: 23px solid #1b6ad2; /* 左边框，设置颜色和宽度 */
      z-index: 4;
    }
    .right {
      width: 100%;
      margin: 45px 26px 45px 20px;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      overflow: auto;
      .news-ul-li {
        background: none;
        overflow-y: scroll;
        padding: 0px 40px 20px;
        margin-bottom: 16px;
        li {
          min-height: 47px;
          border-bottom: 1px solid #14579e;
          &::before {
            top: 22px;
          }
          p {
            font-size: 22px;
            line-height: 50px;
          }
          span {
            font-size: 22px;
            line-height: 50px;
            width: 180px;
          }
        }
      }
      .content-container {
        position: relative;
        height: 100%;
        .description-wrapper {
          position: relative;
          height: auto;
          .link-text {
            color: #2381d4;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          .description {
            height: auto;
            overflow: auto;
            margin-bottom: 20px;
          }
          .mr5 {
            margin-right: 5px;
          }
        }
        .attachments {
          position: absolute;
          bottom: 0;
          left: 0;
          color: #2381d4;
          cursor: pointer;
          .download-document {
            color: #2381d4;
            align-items: center;
            margin-bottom: 12px;
            width: auto;

            .itemName {
              display: inline-block;
              margin: 0 12px;
              width: auto;
              color: #2381d4;
            }
            .el-icon-paperclip {
              cursor: pointer;
              &::before {
                color: #2381d4;
              }
            }

            .el-icon-view,
            .el-icon-download {
              padding: 4px;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #dcdfe6;
              cursor: pointer;
              margin-right: 10px;
              transition: all 0.3s;

              &:hover {
                background-color: #2381d410;
                transform: scale(1.01);
              }
              &::before {
                color: #2381d4;
              }
            }
          }
        }
      }
    }
  }
  .leader {
    width: 100%;
    height: 100%;
    background: url(../../assets/images/back_1.webp) no-repeat;
    background-size: 100% 100%;
    padding: 45px 58px;

    .boxlist {
      height: calc(100% - 10px);
      overflow: auto;
    }
    .list-leadership {
      height: 30px;
      background: url(../../assets/images/back_2.webp) no-repeat;
      background-size: 100% 100%;
      margin-bottom: 20px;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      .position {
        min-width: 160px;
        display: inline-block;
        margin: 0 27px 0 34px;
        color: #fff;
        background: #1b6ad2;
        height: 30px;
        padding-right: 20px;
        line-height: 30px;
        border-radius: 0 10px 0 0;
      }
    }
    .list-leadership:hover {
      color: #1b6ad2;
    }
  }
  .map-info {
    .map {
      width: 100%;
      height: 298px;
      background: url(../../assets/images/img_map.webp) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .info {
      background: #f8f8f8;
      height: 144px;
      width: 100%;
      .flex {
        width: calc(100% / 3);
        padding: 32px 0 0 32px;
        img {
          width: 80px;
          height: 80px;
        }
        p {
          margin-bottom: 0;
          margin-left: 32px;
          b {
            display: block;
            color: #1b6ad2;
            margin-bottom: 4px;
            font-size: 18px;
          }
          span {
            font-family: Microsoft YaHei, Microsoft YaHei;
            display: block;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            line-height: 26px;
          }
        }
      }
    }
  }
  .el-dialog__body {
    height: 100vh;
    padding: 0;
    background: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin: 0 auto;
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: 20px;
    right: 130px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
</style>
